var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.isMobile)?_c('vs-dialog',{attrs:{"blur":_vm.blur,"prevent-close":_vm.preventClose},model:{value:(_vm.visible),callback:function ($$v) {_vm.visible=$$v},expression:"visible"}},[_c(_vm.component,{tag:"component",attrs:{"callback":_vm.callbackMiddleware,"data":_vm.data}})],1):_c('slideout-panel')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }